/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ token: NonNullable<unknown> }} Sitesettings_Error_Tpl_Name1Inputs */

const vi_sitesettings_error_tpl_name1 = /** @type {(inputs: Sitesettings_Error_Tpl_Name1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mẫu mô tả phải có ${i?.token} để đặt tên danh mục / sản phẩm.`)
};

/**

* @param {Sitesettings_Error_Tpl_Name1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_error_tpl_name1 = /** @type {((inputs: Sitesettings_Error_Tpl_Name1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Error_Tpl_Name1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_error_tpl_name1(inputs)
});
export { sitesettings_error_tpl_name1 as "siteSettings_error_tpl_name" }